export default __webpack_public_path__ + "static/media/close.9b1bd08c.svg";